import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
} from '../../shared';
import { IntercompanyAutoStockProcessingQueueContainer } from '../../../../../../models/aggregates/intercompany'


@Injectable({
  providedIn: 'root'
})
export class IntercompanyAutoStockProcessingQueueService extends BaseApiTemplateService<IntercompanyAutoStockProcessingQueueContainer> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'intercompany/auto-stock-processing-queues/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'intercompany/auto-stock-processing-queues/backoffice-ep';
    this.httpClient = http;
  }
  
}
